module.exports = "/* \r\n.row{\r\n    margin-top: 15px;\r\n    padding: 10px;\r\n}\r\n.form-view>.row:nth-child(odd){\r\n    background-color: #d0d0d0;\r\n} */\r\n\r\n.row{\r\n    padding-top:20px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/Leaves/leave-type/leave-type.component.css
// module id = ./src/app/hrms/Attendance-Leaves/Leaves/leave-type/leave-type.component.css
// module chunks = main